var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4ade80",
      stroke: "#000",
      strokeWidth: "4.17px"
    },
    d: "M0 0h512v512H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.047 176.4c-23.68-14.311-46.043-17.417-58.619-24.431-7.001-3.906-24.664-17.25-16.834-17.656 13.058-.676 95.183 13.594 95.183 13.594s37.115-24.355 55.62-30.42c17.626-5.778 33.924-7.406 55.408-5.972 18.794 1.255 45.528 8.092 72.518 23.796 14.599 8.494 32.838 20.521 47.855 32.847 15.331 12.585 44.134 42.66 44.134 42.66L890.067 373.71 714.824 693.904s-197.663-87.222-251.091-114.643c-25.18-12.923-49.119-29.658-69.478-49.886-20.36-20.228-35.197-47.921-52.677-71.482-17.326-23.353-35.655-50.399-52.202-69.881-14.405-16.96-35.227-28.055-47.081-47.012-22.055-35.269-65.746-152.815-85.248-164.6Zm103.155-8.885c11.901 2.927 19.68 14.044 17.36 24.808-2.319 10.765-13.864 17.128-25.764 14.201-11.901-2.927-19.68-14.044-17.36-24.809 2.319-10.764 13.864-17.127 25.764-14.2Z",
    transform: "translate(-72.955 -115.605) scale(1.74026)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f1b7f17a54e971f61e84f33dde2757b.svg";
export { ForwardRef as ReactComponent };